import type { FunctionComponent, ReactNode } from "react";

import { Portal } from "~/components/common/portal";
import { AfterPageLayoutContainerElementID } from "~/pages/_app/consts";

type Props = {
  children?: ReactNode;
};
export const AfterPageLayout: FunctionComponent<Props> = ({ children }) => (
  <Portal selector={`#${AfterPageLayoutContainerElementID}`}>{children}</Portal>
);

AfterPageLayout.displayName = "AfterPageLayout";
